export default function (event) {
  this.croppingLeft += event.x - event.previousX
  this.croppingTop += event.y - event.previousY

  this._croppingLeft += ((event.x - event.previousX))
  this._croppingTop += ((event.y - event.previousY))
  if (this.panend) {
    this.panend = false
  }
}
